/**
 * 性別クラス.
 */
export class Sex {
    static Unknown = "0"; // 不明
    static Women = "1"; // 女性
    static Man = "2"; // 男性

    /**
     * インスタンス変数
     */
    private code: string;

    /**
     * 性別コードを受け取りセットするコンストラクタです.
     *
     * @param code 性別コード
     */
    constructor(code: string) {
        this.code = code;
    }

    /**
     * このオブジェクトのコード値を返却します.
     *
     * @returns コード値
     */
    getCode() : string {
        return this.code;
    }

    /**
     * このオブジェクトのデータが正常であるかどうかを判定します.
     *
     * @returns 正常であればtrue、異常であればfalse
     */
    isValid() : boolean {
        return !(this.code === null || this.code === '');
    }

    /**
     * このオブジェクトのデータが入力済み状態のデータであるかどうかを判定します.
     *
     * @returns 入力済みの状態であればtrue、それ以外の状態であればfalse
     */
    isAlreadyInput() : boolean {
        return !(this.code === null || this.code === '' || this.code === '0');
    }

    /**
     * 性別を日本語で返します.
     *
     * @returns 性別名
     */
    toString(): string | null {
        return this.code === Sex.Women ? "女性" : (this.code === Sex.Man ? "男性" : null);
    }
    /**
     * このオブジェクトが女性を表しているかどうかを返却します.
     *
     * @returns 女性であればtrue、それ以外であればfalse
     */
    isWomen(): boolean  {
        return this.code === Sex.Women;
    }
    /**
     * このオブジェクトが男性を表しているかどうかを返却します.
     *
     * @returns 男性であればtrue、それ以外であればfalse
     */
    isMan(): boolean  {
        return this.code === Sex.Man;
    }
}